module.exports = __webpack_public_path__ + "img/GB-WLS.9f7c50cf.svg";